module.exports = __webpack_public_path__ + "img/109.e727c2be.jpg";